module.exports = __webpack_public_path__ + "static/media/disfraz-familia.974760c3.jpg";